import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

import TicketsManager from "../../components/TicketsManager/";
import Ticket from "../../components/Ticket/";
import InternalChat from "../../components/InternalChat/";

import { i18n } from "../../translate/i18n";
import Hidden from "@material-ui/core/Hidden";
import { useWhiteLabel, getWLChatImage } from "../../context/WhiteLabel/WhiteLabelContext";
import { useThemeContext } from "../../context/DarkMode";

const WelcomePanel = () => {
  const { whiteLabel } = useWhiteLabel();
  const { darkMode } = useThemeContext();
  const chatImage = getWLChatImage(whiteLabel, darkMode);
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", gap: 24, padding: 32 }}>
      {chatImage && (
        <img src={chatImage} alt={whiteLabel?.name || ""} style={{ maxWidth: 280, maxHeight: 220, objectFit: "contain", opacity: 0.85 }} />
      )}
      <span style={{ color: "inherit", opacity: 0.6, fontSize: 14, textAlign: "center" }}>
        {i18n.t("chat.noTicketMessage")}
      </span>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  chatContainer: {
    flex: 1,
    // // backgroundColor: "#eee",
    // padding: theme.spacing(4),
    height: `calc(100% - 48px)`,
    overflowY: "hidden",
    backgroundColor: theme.palette.background.default,
  },

  chatPapper: {
    // backgroundColor: "red",
    display: "flex",
    height: "100%",
    backgroundColor: theme.palette.background.paper,
  },

  contactsWrapper: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflowY: "hidden",
  },
  contactsWrapperSmall: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflowY: "hidden",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  messagessWrapper: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
  },
  welcomeMsg: {
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    textAlign: "center",
    borderRadius: 0,
  },
  ticketsManager: {},
  ticketsManagerClosed: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

const Chat = () => {
  const classes = useStyles();
  const { ticketId } = useParams();
  const [internalChatUser, setInternalChatUser] = useState(null);
  const internalChatUserRef = useRef(null);

  // Keep ref in sync with state so TicketsManager can read current value
  useEffect(() => {
    internalChatUserRef.current = internalChatUser;
  }, [internalChatUser]);

  // When a ticket is selected from normal tabs, clear the internal chat
  const handleSelectInternalUser = (userObj) => {
    setInternalChatUser(userObj);
  };

  const handleBackFromInternalChat = () => {
    setInternalChatUser(null);
  };

  // Whether the right panel is occupied (ticket or internal chat)
  const rightPanelActive = !!ticketId || !!internalChatUser;

  return (
    <div className={classes.chatContainer}>
      <div className={classes.chatPapper}>
        <Grid container spacing={0}>
          {/* <Grid item xs={4} className={classes.contactsWrapper}> */}
          <Grid
            item
            xs={12}
            md={4}
            className={
              rightPanelActive ? classes.contactsWrapperSmall : classes.contactsWrapper
            }
          >
            <TicketsManager onSelectInternalUser={handleSelectInternalUser} ticketId={ticketId} internalChatUserRef={internalChatUserRef} />
          </Grid>
          <Grid item xs={12} md={8} className={classes.messagessWrapper}>
            {/* <Grid item xs={8} className={classes.messagessWrapper}> */}
            {internalChatUser ? (
              <InternalChat
                user={internalChatUser}
                onBack={handleBackFromInternalChat}
              />
            ) : ticketId ? (
              <>
                <Ticket />
              </>
            ) : (
              <Hidden only={["sm", "xs"]}>
                <Paper className={classes.welcomeMsg}>
                  <WelcomePanel />
                </Paper>
              </Hidden>
            )}
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Chat;
